import IAdditionalOfferGet from 'api/interfaces/offers/IAdditionalOfferGet';

const additionalOfferRetrieved = (result: IAdditionalOfferGet): boolean =>
  result !== undefined &&
  result.description !== undefined &&
  result.offerId !== undefined &&
  result.status !== undefined;

export default additionalOfferRetrieved;
